import { render, staticRenderFns } from "./ComplianceReport.vue?vue&type=template&id=a52aa446&scoped=true"
import script from "./ComplianceReport.vue?vue&type=script&lang=js"
export * from "./ComplianceReport.vue?vue&type=script&lang=js"
import style0 from "./ComplianceReport.vue?vue&type=style&index=0&id=a52aa446&prod&scoped=true&lang=css"
import style1 from "./ComplianceReport.vue?vue&type=style&index=1&id=a52aa446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52aa446",
  null
  
)

export default component.exports